import Vue from 'vue'
Vue.directive('focus', {
  // 当绑定元素插入到DOM中
  bind: function (el, binding) {
    console.log('1 - bind')
    /**
     - 如果所有的列表的checked属性都为true,则选中全选框,否则不选中全选框
     */
    console.log(binding.value)
  },
  inserted: function (el, binding) {
    console.log('2 - inserted')
    console.log(binding.value)
    el.focus() // 元素聚焦
    el.setAttribute('placeholder', '自定义内容')
  },
  update: function (el, binding) { // 组件更新
    console.log('3 - update')
    console.log(binding.value)
    /**
     - 如果全选框被选中,则将列表的所有checked属性转为true,否则转为false
     */
    if (binding.value.state === true) {
      binding.value.list.forEach((item) => {
        item.checked = true
      })
    } else {
      binding.value.list.forEach((item) => {
        item.checked = false
      })
    }
  },
  componentUpdated: function (el, binding) { // 组件更新完成
    console.log('4 - componentUpdated')
    console.log(binding.value)
  },
  unbind: function (el, binding) { // 解绑
    console.log('5 - bind')
    console.log(binding.value)
  }
})
Vue.directive('debounceClick', { // 防止重复点击
  inserted (el, binding) {
    el.addEventListener('click', e => {
      if (!el.disabled) {
        el.disabled = true;
        let timer = setTimeout(() => {
          el.disabled = false;
        }, 1000)
      }
    })
  }
})
Vue.directive('check-all', {
  twoWay: true,
  params: ['checkData'],
  bind (el, binding) {
    binding.$watch(this.params.checkData, (checkData) => {
      if (checkData.every((item) => item.checked)) {
        this.set(true);
      } else {
        this.set(false);
      }
    }, {
      deep: true
    })
  },
  update (checkAll) {
    if (checkAll) {
      this[this.params.checkData].forEach((item) => {
        item.checked = true;
      });
    } else {
      this[this.params.checkData].forEach((item) => {
        item.checked = false;
      });
    }
  }
})
export default { Vue }



// WEBPACK FOOTER //
// ./src/directives/directive.js